export default {
  title: 'LCL Rate Management',
  createTitle: 'Create LCL Rate',
  editTitle: 'Edit LCL Rate',
  viewTitle: 'LCL Rate Detail',
  copyTitle: 'Copy LCL Rate',
  filters: {
    priceNo: 'Rate No.',
    carrier: 'Carrier',
    pol: 'POL',
    pod: 'POD',
    por: 'Place of Receipt',
    pdl: 'Place of delivery',
    podRouteCategory: 'POD Route Category',
    rateType: 'Rate Type',
    status: 'Status',
    validity: 'Validity',
    originCountry: 'Origin Country',
    destinationCountry: 'Destination Country',
    originCity: 'Origin City',
    destinationCity: 'Destination City',
    placeOfDelivery: 'Place of Delivery',
    portOfDischarge: 'Port of Discharge',
    supplier: 'Supplier',
    office: 'Office',
    cargoType: 'Cargo Type',
    directFlag: 'Direct/Transit',
    transferPort: 'Transfer Port',
    lane: 'Lane',
    onePrice: 'All-in Price',
    validPeriod: 'Validity'
  },
  placeholders: {
    priceNo: 'Enter rate number',
    source: 'Please select source',
    office: 'Please select office',
    supplier: 'Please select supplier',
    carrier: 'Select carrier',
    pol: 'Select POL',
    pod: 'Select POD',
    por: 'Select place of receipt',
    pdl: 'Select place of delivery',
    portOfDischarge: 'Select port of discharge',
    placeOfDelivery: 'Select place of delivery',
    podRouteCategory: 'Select POD route category',
    transportTerm: 'Select transport term',
    validityDate: 'Select validity date',
    directFlag: 'Select direct/transit',
    rateType: 'Select rate type',
    status: 'Select status',
    validity: 'Select validity',
    originCountry: 'Select origin country',
    destinationCountry: 'Select destination country',
    originCity: 'Select origin city',
    destinationCity: 'Select destination city',
    transferPort: 'Select transfer port',
    lane: 'Select lane',
    onePrice: 'Select all-in price',
    validPeriod: 'Select validity range',
    cargoType: 'Select cargo type',
    cargoDescription: 'Enter cargo description',
    remark: 'e.g. cutoff time, special requirements, unstuffing place',
    relationNo: 'Inquiry/Tender No.',
    contractNo: 'Contract No.',
    laneCodes: 'Enter lane codes',
    departureDate: 'Select departure date',
    closingDate: 'Select closing date',
    sellPrice: 'Ocean freight price',
    minCharge: 'Min charge',
    nac: 'Enter NAC',
    vessel: 'Enter vessel name',
    voyage: 'Enter voyage',
    eta: 'Select ETA',
    etd: 'Select ETD',
    specialPriceStatus: 'Select special price status'
  },
  columns: {
    priceNo: 'Rate No.',
    rateType: 'Rate Type',
    carrier: 'Carrier',
    supplier: 'Supplier',
    pol: 'POL',
    pod: 'POD',
    pdl: 'Place of Delivery',
    source: 'Rate Source',
    chargeUnit: 'Unit',
    costPrice: 'Cost',
    sellPrice: 'Sell',
    spaceStatus: 'Space Status',
    validity: 'Validity',
    status: 'Status',
    actions: 'Actions',
    feeName: 'Fee Name',
    feeType: 'Fee Type',
    unit: 'Unit',
    price: 'Price',
    currency: 'Currency',
    minCharge: 'Min',
    maxCharge: 'Max',
    payParam: 'Pay Param',
    payTerm: 'Pay Term',
    feeSource: 'Fee Source',
    oldValidity: 'Old Validity',
    conflictType: 'Conflict Type',
    resolution: 'Resolution'
  },
  fields: {
    priceNo: 'Rate No.',
    rateType: 'Rate Type',
    carrier: 'Carrier',
    supplier: 'Supplier',
    cargoType: 'Cargo Type',
    cargoDescription: 'Cargo Description',
    spaceStatus: 'Space Status',
    priceTrend: 'Price Trend',
    office: 'Office',
    contractNo: 'Contract No.',
    transportTerm: 'Transport Mode',
    pol: 'POL',
    pod: 'POD',
    transferPort: 'Transfer Port',
    validityDate: 'Validity',
    transitTime: 'Transit Time (Days)',
    chargeUnit: 'Unit',
    currency: 'Currency',
    costPrice: 'Cost Price',
    sellPrice: 'Sell Price',
    payTerm: 'Pay Term',
    minCharge: 'Min Charge',
    handlingFee: 'Handling Fee',
    customsFee: 'Customs Fee',
    baf: 'BAF',
    docFee: 'DOC Fee',
    directFlag: 'Direct/Transit',
    source: 'Source',
    relationNo: 'Relation No.',
    tradeTerm: 'Trade Term',
    routeType: 'Route Type',
    nac: 'NAC',
    por: 'Place of Receipt',
    pdl: 'Place of Delivery',
    placeOfDelivery: 'Place of Receipt',
    portOfDischarge: 'Port of Discharge',
    podRouteCategory: 'POD Route',
    polTerminal: 'POL Terminal',
    podTerminal: 'POD Terminal',
    vessel: 'Vessel',
    voyage: 'Voyage',
    schedule: 'Schedule',
    etd: 'ETD',
    eta: 'ETA',
    closingDate: 'Closing',
    departureDate: 'Departure',
    freeDetention: 'Free Detention (Days)',
    freeDemurrage: 'Free Demurrage (Days)',
    unstuffing: 'Unstuffing',
    unstuffingPlace: 'Unstuffing Place',
    receivingInstructions: 'Special Receiving Instructions',
    onePrice: 'One Price',
    weightLimit: 'Weight Limit (KG)',
    laneCodes: 'Lane Code',
    departureSchedule: 'Departure Schedule',
    closing_schedule: 'Closing Schedule',
    remark: 'Remark',
    baseOceanFreight: 'Base Ocean Freight',
    manualAdd: 'Manual Add',
    systemRule: 'System Rule',
    userCreated: 'User Created',
    viewRule: 'View Rule',
    validPeriod: 'Validity',
    specialPriceStatus: 'Special Price Status'
  },
  enums: {
    source: {
      1: 'Manual',
      2: 'Inquiry',
      3: 'Tender',
      manual: 'Manual',
      inquiry: 'Inquiry',
      tender: 'Tender'
    },
    spaceStatus: {
      1: 'Open',
      2: 'Normal',
      3: 'On Request',
      4: 'Full',
      5: 'Closed'
    },
    status: {
      1: 'Draft',
      2: 'Normal',
      3: 'Expired',
      4: 'Offline',
      5: 'Disabled',
      6: 'Pending'
    },
    cargoTypes: {
      general: 'General',
      dangerous: 'Dangerous'
    },
    rateTypes: {
      1: 'Carrier Rate',
      2: 'NVO Rate',
      3: 'E-comm Rate',
      4: 'Supplier Rate'
    },
    chargeUnits: {
      cbm: 'CBM (Volume)',
      kg: 'KG (Weight)',
      weight: 'RT (Billing Weight)'
    },
    payTerms: {
      prepaid: 'Prepaid',
      collect: 'Collect'
    },
    directFlags: {
      direct: 'Direct',
      transit: 'Transit',
      both: 'Direct/Transit'
    },
    routeTypes: {
      ocean: 'Direct',
      inland: 'Transit'
    },
    specialPriceStatus: {
      1: 'Special price not allowed',
      2: 'Special price allowed',
      3: 'Special price'
    },
    surchargeTypes: {
      OCEAN_EXTRA: 'OCEAN EXTRA',
      POR: 'POR Charges',
      FND: 'POD Charges'
    }
  },
  sections: {
    basicInfo: 'Basic Info',
    routeInfo: 'Sailing Info',
    feeInfo: 'Fee Detail',
    surchargeDetail: 'Surcharges',
    rateDetails: 'Rate Details',
    oceanFreight: 'Ocean Freight',
    oceanFreightSurcharge: 'Ocean Freight Surcharge',
    polSurcharge: 'Origin Port Charges',
    podSurcharge: 'Destination Port Charges',
    remark: 'Remark'
  },
  actions: {
    add: 'New LCL Rate',
    query: 'Search',
    reset: 'Reset',
    edit: 'Edit',
    view: 'View',
    copy: 'Copy',
    delete: 'Delete',
    publish: 'Publish',
    disable: 'Disable',
    enable: 'Enable',
    batchOperations: 'Batch Operations',
    batchPublish: 'Batch Publish',
    batchOffline: 'Batch Offline',
    batchPriceChange: 'Batch Price Change',
    batchTimeChange: 'Batch Time Change',
    batchDelete: 'Batch Delete',
    import: 'Import',
    export: 'Export',
    downloadTemplate: 'Template',
    aiRecognition: 'AI Recognition',
    more: 'More',
    back: 'Back',
    saveDraft: 'Save Draft',
    unbind: 'Unbind',
    addFeeManually: 'Add Fee',
    offline: 'Offline',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  messages: {
    fetchFailed: 'Failed to fetch data',
    loadDataFailed: 'Failed to load data',
    saveSuccess: 'Draft saved successfully',
    publishSuccess: 'Successfully published {count} rates',
    deleteSuccess: 'Successfully deleted {count} rates',
    offlineSuccess: 'Successfully offlined {count} rates',
    deleteConfirm: 'Delete the selected {count} rates? This cannot be undone.',
    systemMatched: 'System matched',
    importSuccess: 'Imported successfully',
    generatingErrorReport: 'Generating report...',
    downloadingTemplate: 'Downloading template...',
    onlyDraftCanPublish: 'Only draft and pending-import rates can be published. Selection includes: {status}',
    onlyNormalCanOffline: 'Only published rates can be offlined. Selection includes: {status}',
    onlyDraftCanDelete: 'Only draft rates can be deleted. Selection includes: {status}',
    offlineConfirm: 'Offline the selected {count} rates?',
    noSelection: 'Please select at least one record',
    batchUpdateSuccess: 'Batch update success',
    selectValidity: 'Please select validity period',
    onlyDraftCanModify: 'Only draft status can be modified',
    recordsToModify: 'Rates to be modified',
    selectedCount: '{count} items selected',
    noSurchargeRuleId: 'Surcharge rule ID not found',
    unknownSurchargeType: 'Unknown surcharge type, cannot jump',
    comingSoon: 'Coming Soon',
    exportFilename: 'LCL Rates Export',
    templateDownloadFailed: 'Template download failed'
  },
  batch: {
    timeChange: {
      currentEtd: 'Current ETD',
      currentEta: 'Current ETA',
      currentValidPeriod: 'Current Validity'
    }
  },
  modals: {
    conflictTitle: 'Validity Conflict Detected',
    processing: 'Processing...',
    confirmProcessing: 'Confirm & Publish',
    cancelPublish: 'Cancel',
    conflictAlert: 'Detected {count} existing rates with overlapping validity.',
    upcomingRate: 'New Rate',
    conflictDetail: 'Conflict Detail',
    ruleTitle: 'Auto-processing Rules',
    rule1: 'Exact Match',
    rule2: 'New covers Old',
    rule3: 'Overlap',
    rule4: 'Old covers New'
  },
  aiRecognition: {
    title: 'AI Smart Recognition',
    uploadTitle: 'Upload Rate File',
    uploadDesc: 'Click or drag file here, system will automatically recognize content and extract rate info',
    processing: 'AI Recognizing...',
    processingDesc: 'Please wait, AI is analyzing your rate file...',
    success: 'Recognized successfully!',
    successDesc: 'Rate info successfully recognized and imported',
    error: 'Recognition failed',
    errorDesc: 'File recognition failed, please check format or re-upload',
    retry: 'Re-upload',
    aiDescription: 'AI Recognition Info',
    aiFeatures: [
      'AI will automatically recognize ports, carriers, prices etc.',
      'Supports multiple formats and complex table structures',
      'Background task will be created after identification',
      'Please ensure uploaded files are clear and readable'
    ],
    successTitle: 'AI task submitted',
    successDescription: 'Task is running in background. Please check progress in <strong>System Settings - Task Management</strong>.',
    goToTaskManagement: 'Go to Tasks',
    close: 'Close',
    uploadFile: 'Upload {type} file',
    clickOrDrag: 'Click or drag file here to upload',
    supportedFormats: 'Formats: PDF, Excel, Word, Image etc.',
    selectFile: 'Select File',
    aiParsing: 'AI Parsing...',
    aiParsingTip: 'AI is parsing document, please wait...'
  },
  form: {
    sections: {
      basicInfo: 'Basic Info',
      routeInfo: 'Route Info',
      validityInfo: 'Validity Info',
      feeInfo: 'Fee Detail',
      specialTerms: 'Special Terms',
      remark: 'Remark'
    },
    labels: {
      priceName: 'Rate Name',
      supplier: 'Supplier',
      carrier: 'Carrier',
      pol: 'POL',
      pod: 'POD',
      transitPort: 'Transit Port',
      validityDate: 'Validity',
      transitTime: 'Transit Time (Days)',
      chargeUnit: 'Charge Unit',
      currency: 'Currency',
      freightPrice: 'Freight Unit Price',
      minCharge: 'Min Charge',
      handlingFee: 'Handling Fee',
      customsFee: 'Customs Fee',
      baf: 'BAF (Bunker Adjustment Factor)',
      docFee: 'Documentation Fee',
      freeStorageDays: 'Free Storage Days',
      volumeLimit: 'Volume Limit (CBM)',
      weightLimit: 'Weight Limit (KG)',
      specialCargoRemark: 'Special Cargo Remark',
      remark: 'Remark'
    },
    placeholders: {
      priceName: 'Enter rate name',
      supplier: 'Select supplier',
      carrier: 'Select carrier',
      pol: 'Select POL',
      pod: 'Select POD',
      transitPort: 'Select transit port (multiple)',
      transitTime: 'Enter estimated transit days',
      currency: 'Select currency',
      freightPrice: 'Enter freight unit price',
      minCharge: 'Enter min charge amount',
      handlingFee: 'Enter handling fee',
      customsFee: 'Enter customs fee',
      baf: 'Enter bunker adjustment factor',
      docFee: 'Enter documentation fee',
      freeStorageDays: 'Enter free storage days',
      volumeLimit: 'Enter max volume limit',
      weightLimit: 'Enter max weight limit',
      specialCargoRemark: 'Enter special cargo remark, e.g. battery, dangerous goods',
      remark: 'Enter additional notes'
    },
    options: {
      chargeUnitWeight: 'Chargeable Weight'
    },
    validation: {
      priceName: 'Please enter rate name',
      supplier: 'Please select supplier',
      carrier: 'Please select carrier',
      pol: 'Please select POL',
      pod: 'Please select POD',
      validityDate: 'Please select validity',
      chargeUnit: 'Please select charge unit',
      currency: 'Please select currency',
      freightPrice: 'Please enter freight unit price'
    },
    ports: {
      CNSHA: 'Shanghai Port (CNSHA)',
      CNSZX: 'Shenzhen Port (CNSZX)',
      CNYTN: 'Yantian Port (CNYTN)',
      USLAX: 'Los Angeles Port (USLAX)',
      NLRTM: 'Rotterdam Port (NLRTM)',
      DEHAM: 'Hamburg Port (DEHAM)'
    }
  }
}
